module.exports = __webpack_public_path__ + "static/mockup1-7e88aff5ded5844ca1765e1595f1b861.png";